/**
 * Fetches city and state for a given 6-digit Indian pincode.
 * Uses https://api.postalpincode.in/pincode/:pincode
 */
export const fetchPincodeDetailsAction = async (pincode) => {
    try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        const data = await response.json();

        const result = data?.[0];

        if (!result || result.Status === "Error" || result.Status === "404") {
            return { success: false, error: "Invalid pincode. Please enter a valid 6-digit pincode." };
        }

        const postOffice = result.PostOffice?.[0];
        if (!postOffice) {
            return { success: false, error: "No details found for this pincode." };
        }

        return {
            success: true,
            city: postOffice.District || postOffice.Block || "",
            state: postOffice.State || "",
        };
    } catch {
        return { success: false, error: "Failed to fetch pincode details. Please try again." };
    }
};
